export function removeLocalStorageItems() {
  const keys = [
    'Title', 'shva', 'currentNavigationLink', 'IsNotificationShown', 'userType', 'usertype',
    'sourceName', 'tenants', 'isVerticalTabPosition', 'accesstoken', 'powerBIAccessTokenTime', 'decisionMaker'
  ];
  keys.forEach(key => localStorage.removeItem(key));
}